import type Phaser from "phaser";

export const GAME_FONT = '"Pixelify Sans", ui-monospace, monospace';

/**
 * Text style for world-space labels. Text is rasterized at the camera zoom so
 * it isn't drawn at 8px and then nearest-neighbour upscaled (pixelArt mode).
 */
export function worldTextStyle(
  scene: Phaser.Scene,
  style: Phaser.Types.GameObjects.Text.TextStyle,
): Phaser.Types.GameObjects.Text.TextStyle {
  return {
    fontFamily: GAME_FONT,
    resolution: Math.max(1, Math.ceil(scene.cameras.main.zoom)),
    ...style,
  };
}
